import React, { useState, useEffect } from "react"
import {
    Row,
    Col,
    Input,
    Tooltip,
    Icon,
    Divider,
    Checkbox,
    Button,
    Upload,
} from "antd"
const { Dragger } = Upload


export default function WhitelistRequest({ onSendFile }) {

    const [fileList, setFileList] = useState([])

    const beforeUploadFile = (file) => {
        onSendFile(file)
        setFileList([file])
        return false
    }

    const onRemove = () => {
        onSendFile(null)
        setFileList([])
    }

    return (
        <>
            <Col >
                <label
                    className="control-label"
                    style={{
                        whiteSpace: "nowrap",
                    }}
                >
                    Request Whitelist Documents <span style={{ color: "red" }}>*</span>
                </label>
                <div className="d-flex">
                    <div className="mr-1">Example File:</div>
                    <div>
                        <a target="_blank" href="https://www.ants.co.th/file/Example%20Document%20Whitelist%20Letter.pdf">Preview</a>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="mr-1">Document File:</div>
                    <div>
                        <a target="_blank" href="/docs/Whitelist-Letter-template-8.1.2017-1.docx">Download</a>
                    </div>
                </div>
                <Dragger
                    accept={".jpg,.png,.pdf,.docx"}
                    beforeUpload={beforeUploadFile}
                    onRemove={onRemove}
                    fileList={fileList}
                // fileList={props.data.RSD_IDEN_DOC}
                // {...props}
                >
                    <p className="ant-upload-drag-icon icon-upload">
                        <Icon type="upload" style={{ color: "#000" }} />
                    </p>
                    <div className="ant-upload-text" style={{ lineHeight: "15px" }}>
                        <p>Drag and drop here (.jpg .png .pdf .docx)</p>
                        <p>or</p>
                        <p style={{ color: "#097FF5" }}>Browse</p>
                    </div>
                </Dragger>
            </Col>
        </>
    )
}